<template>
  <div id="SiteChangePassword" class="Main-Content">

    <Page>
      <Layout>
        <LayoutSection>
          <Card :title="$t('Change Password')">
            <CardSection>

              <div v-if="error" class="message error">{{ error }}</div>

              <FormLayout>
                <TextField
                  :label="$t('New Password')"
                  type="password"
                  v-model="newPassword"
                />
                <TextField
                  :label="$t('Repeat New Password')"
                  type="password"
                  v-model="newPasswordRepeat"
                />
                <Button @click="changePassword" type="primary">{{ $t('Change Password') }}</Button>
              </FormLayout>

            </CardSection>
          </Card>
        </LayoutSection>
      </Layout>
    </Page>

  </div>
</template>

<script>

export default {
  name: 'SiteChangePassword',
  data () {
    return {
      loading: true,
      newPassword: '',
      newPasswordRepeat: ''
    }
  },
  methods: {
    changePassword() {
      if (!this.newPassword.trim() || !this.newPasswordRepeat.trim()) {
        this.$ui.alert({
          title: 'Alert',
          content: this.$t('Password Required')
        })
        return        
      }
      if (this.newPassword !== this.newPasswordRepeat) {
        this.$ui.alert({
          title: 'Alert',
          content: this.$t('Passwords must match')
        })
        return
      }

      const { id, hash } = this.$route.params

      NProgress.start()
      this.api.changeForgottenPassword(id, hash, this.newPassword)
      .then(() => {
        this.$ui.toast({ title: this.$t('Password Updated') })
        this.$router.push('/site/login/')
      })
      .catch(this.apiCatch)
      .finally(() => {
        NProgress.done()
      })
    }
  },
}

</script>

<style lang="scss" scoped>
.message {
  padding: 5px;
}
.error {
  color: #c00;
  font-weight: bold;
  margin-bottom: 20px;
}
</style>
